import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { RequisitionsConfigHttpClient } from './config.http-client';
import { RequisitionsConfigActions } from './config.store';

@Injectable({ providedIn: 'root' })
export class RequisitionsConfigEffects {
  public effects = createEffectFactory(RequisitionsConfigActions, this.actions$);

  public fetch$ = this.effects(RequisitionsConfigActions.fetch, () =>
    this.http.fetch().pipe(map(data => data.settings)),
  );

  public toggleFeature$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RequisitionsConfigActions.enable, RequisitionsConfigActions.disable),
      switchMap(action => {
        const isEnable = action.type === RequisitionsConfigActions.enable.type;
        const successAction = isEnable
          ? RequisitionsConfigActions.enableSuccess
          : RequisitionsConfigActions.disableSuccess;
        const failedAction = isEnable
          ? RequisitionsConfigActions.enableFailed
          : RequisitionsConfigActions.disableFailed;
        return this.http.update({ settings: { enabled: isEnable } }).pipe(
          map(data => successAction({ payload: data.settings })),
          catchError(error => of(failedAction({ payload: error }))),
        );
      }),
    ),
  );

  public update$ = this.effects(RequisitionsConfigActions.update, ({ payload }) =>
    this.http.update({ settings: payload }).pipe(map(data => data.settings)),
  );

  public updateWithDepartments$ = this.effects(
    RequisitionsConfigActions.updateWithDepartments,
    ({ payload }) =>
      this.http.update({ settings: payload }).pipe(
        map(data =>
          RequisitionsConfigActions.updateWithDepartmentsSuccess({ payload: data.settings }),
        ),
        catchError(error =>
          of(RequisitionsConfigActions.updateWithDepartmentsFailed({ payload: error })),
        ),
      ),
  );

  public updateRequiredForOffers$ = this.effects(
    RequisitionsConfigActions.updateRequiredForOffers,
    ({ payload }) =>
      this.http.update({ settings: payload }).pipe(
        map(data =>
          RequisitionsConfigActions.updateRequiredForOffersSuccess({
            payload: data.settings,
          }),
        ),
        catchError(error =>
          of(RequisitionsConfigActions.updateRequiredForOffersFailed({ payload: error })),
        ),
      ),
  );

  public updateAutoCreateJobs$ = this.effects(
    RequisitionsConfigActions.updateAutoCreateJobs,
    ({ payload }) =>
      this.http.update({ settings: payload }).pipe(
        map(data =>
          RequisitionsConfigActions.updateAutoCreateJobsSuccess({
            payload: data.settings,
          }),
        ),
        catchError(error =>
          of(RequisitionsConfigActions.updateAutoCreateJobsFailed({ payload: error })),
        ),
      ),
  );

  constructor(
    private actions$: Actions,
    private http: RequisitionsConfigHttpClient,
  ) {}
}
